const PersonTypeSelector = ({ activeBtn, setActiveBtn }) => {
    return (
        <div className="modal-box__btns">
            {/* <p>¿Eres persona natural o empresa?</p> */}
            <div>
                <button
                    className={activeBtn === "person" ? "--active" : ""}
                    onClick={() => setActiveBtn("person")}
                >
                    <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M11.9962 28.0003V11.7003C10.1518 11.2114 8.64624 10.2337 7.47958 8.76699C6.31291 7.30033 5.61846 5.63366 5.39624 3.76699C5.3518 3.45588 5.46291 3.19477 5.72958 2.98366C5.99624 2.77255 6.30735 2.66699 6.66291 2.66699C7.01846 2.66699 7.32958 2.76144 7.59624 2.95033C7.86291 3.13921 8.01846 3.40033 8.06291 3.73366C8.30735 5.33366 8.99624 6.66699 10.1296 7.73366C11.2629 8.80033 12.6629 9.33366 14.3296 9.33366H17.6629C18.3296 9.33366 18.9518 9.45588 19.5296 9.70033C20.1074 9.94477 20.6296 10.3003 21.0962 10.767L26.1962 15.867C26.4407 16.1114 26.5629 16.4225 26.5629 16.8003C26.5629 17.1781 26.4407 17.4892 26.1962 17.7337C25.9518 17.9781 25.6407 18.1003 25.2629 18.1003C24.8851 18.1003 24.574 17.9781 24.3296 17.7337L19.9962 13.4003V28.0003C19.9962 28.3781 19.8685 28.6948 19.6129 28.9503C19.3574 29.2059 19.0407 29.3337 18.6629 29.3337C18.2851 29.3337 17.9685 29.2059 17.7129 28.9503C17.4574 28.6948 17.3296 28.3781 17.3296 28.0003V21.3337H14.6629V28.0003C14.6629 28.3781 14.5351 28.6948 14.2796 28.9503C14.024 29.2059 13.7074 29.3337 13.3296 29.3337C12.9518 29.3337 12.6351 29.2059 12.3796 28.9503C12.124 28.6948 11.9962 28.3781 11.9962 28.0003Z"
                            fill="#243649"
                        />
                        <path
                            d="M15.9987 8.00033C15.2654 8.00033 14.6376 7.73921 14.1154 7.21699C13.5931 6.69477 13.332 6.06699 13.332 5.33366C13.332 4.60033 13.5931 3.97255 14.1154 3.45033C14.6376 2.9281 15.2654 2.66699 15.9987 2.66699C16.732 2.66699 17.3598 2.9281 17.882 3.45033C18.4043 3.97255 18.6654 4.60033 18.6654 5.33366C18.6654 6.06699 18.4043 6.69477 17.882 7.21699C17.3598 7.73921 16.732 8.00033 15.9987 8.00033Z"
                            fill="#CC100F"
                        />
                    </svg>
                    <p>Persona Natural</p>
                </button>
                <button
                    className={activeBtn === "company" ? "--active" : ""}
                    onClick={() => setActiveBtn("company")}
                >
                    <svg
                        width="32"
                        height="32"
                        viewBox="0 0 32 32"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M2.66797 25.3333V6.66667C2.66797 5.93333 2.92908 5.30556 3.4513 4.78333C3.97352 4.26111 4.6013 4 5.33464 4H13.3346C14.068 4 14.6957 4.26111 15.218 4.78333C15.7402 5.30556 16.0013 5.93333 16.0013 6.66667V9.33333H26.668C27.4013 9.33333 28.0291 9.59444 28.5513 10.1167C29.0735 10.6389 29.3346 11.2667 29.3346 12V25.3333C29.3346 26.0667 29.0735 26.6944 28.5513 27.2167C28.0291 27.7389 27.4013 28 26.668 28H5.33464C4.6013 28 3.97352 27.7389 3.4513 27.2167C2.92908 26.6944 2.66797 26.0667 2.66797 25.3333ZM5.33464 25.3333H8.0013V22.6667H5.33464V25.3333ZM5.33464 20H8.0013V17.3333H5.33464V20ZM5.33464 14.6667H8.0013V12H5.33464V14.6667ZM5.33464 9.33333H8.0013V6.66667H5.33464V9.33333ZM10.668 25.3333H13.3346V22.6667H10.668V25.3333ZM10.668 20H13.3346V17.3333H10.668V20ZM10.668 14.6667H13.3346V12H10.668V14.6667ZM10.668 9.33333H13.3346V6.66667H10.668V9.33333ZM16.0013 25.3333H26.668V12H16.0013V14.6667H18.668V17.3333H16.0013V20H18.668V22.6667H16.0013V25.3333Z"
                            fill="#243649"
                        />
                        <path
                            d="M21.332 17.3337V14.667H23.9987V17.3337H21.332ZM21.332 22.667V20.0003H23.9987V22.667H21.332Z"
                            fill="#CC100F"
                        />
                    </svg>
                    <p>Empresa</p>
                </button>
            </div>
        </div>
    );
};

export default PersonTypeSelector;
